import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const AddIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 20 20" fill="none" ref={ref} {...props}>
          <path
            d="M2 10H10M18 10H10M10 2V10M10 18L10 10"
            stroke="currentcolor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

AddIcon.displayName = "AddIcon";
